import React, { Component } from 'react';
import MeasurementList from './MeasurementList';
import MeasurementSave from './MeasurementSave';
import WithRouter from 'custom/withRouter';

class MeasurementPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const p = this.props;
        const weightId = p.params.id;
        const isSave = weightId || p.location.pathname === "/manage/measurement/add";
        return (
            <React.Fragment>
                {
                    isSave
                        ?
                        <MeasurementSave
                            name="measurementSave"
                            params={p.params}
                            title="Measurement Setting Info" />
                        :
                        <MeasurementList title="List of Measurement Settings" />
                }
            </React.Fragment>
        );
    }
}

export default WithRouter(MeasurementPage);